<template>
  <div>
    <Headersys />
    <div class="content">
      <div>
        身份证读取
      </div>
      <el-button type="primary" @click="websopen">打开usb设备</el-button>
      <el-button type="success" @click="readCard">读卡</el-button>
      <img class="sign-img" :src="imgUrl" alt="">
      <!-- <el-button type="info">结束签名</el-button> -->
      <!-- <el-button type="warning">获取笔迹图片</el-button> -->
      <!-- <el-button type="danger">获取设备序列号</el-button> -->
      <div class="idcard-title" @dblclick="clear">
        <div v-for="(item, idx) in msgList" :key="idx">
          {{ item }}
        </div>
      </div>
      <img class="gpy-img" :src="baseImg" alt="">
      <img class="gpy-img" :src="photoImg" alt="">
      <el-button type="primary" @click="getGPY">获取设备信息</el-button>
      <el-button type="success" @click="openGPY">打开摄像头</el-button>
      <el-button type="info" @click="takePhoto">拍照</el-button>
      <el-button type="info" @click="takePhotoZP">展平拍照</el-button>
      <el-button type="warning" @click="coloseGPY">关闭摄像头</el-button>
      <div style="height: 20vh;"></div>
    </div>
    <Back />
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      //29999
      wsUri: "ws://127.0.0.1:9321/",//汉王签字版链接
      webSkt: null,
      msgList: [],
      imgUrl: "",//身份证照片
      baseImg: "",//视频
      photoImg: "",//照片
      farmTime: null,//高拍仪获取帧定时器
    };
  },
  created() {
  },
  mounted() {
  },
  // destroyed() {
  //   this.webSkt.close()
  // },
  methods: {
    // 读卡
    readCard() {
      this.doSend('{"method":"readIDCard","finger":"0","type":"1"}');
    },
    // 建立websocket链接
    websopen() {
      this.webSkt = new WebSocket(this.wsUri);
      this.webSkt.onopen = (evt) => {
        console.log('身份证就绪', evt);
        this.msgList.push('USB设备已启动')
        // var data = { method: "openUSB" }
        // var msg = JSON.stringify(data)
        this.doSend('{"method":"openUSB"}');
      };
      this.webSkt.onmessage = (evt) => {
        this.msgList.push('收到数据:' + evt.data)
        var jsondata = JSON.parse(evt.data);
        this.onMessage(jsondata)
      };
      this.webSkt.onerror = (evt) => {
        console.log('PC端服务中间件未运行', evt);
        this.msgList.push('PC端服务中间件未运行')
      };
    },
    doSend(message) {
      // { HWPenSign } 传参Key
      // HWInitialize  开始签名
      // HWFinalize    清除窗口笔记
      // HWClearSign   结束签名
      // HWGetSign     获取笔迹图片
      // HWGetDeviceId 获取设备序列号
      this.webSkt.send(message);
    },
    onMessage(jsondata) {
      // var jsondata = JSON.parse(evt.data);
      console.log('返回信息测试', jsondata);
      if (jsondata.method == 'readIDCard' && jsondata.msg == "读卡失败") {
        this.doSend('{"method":"readIDCard","finger":"0","type":"1"}');
      }
      if (jsondata.msg == "读卡成功") {
        var str = `姓名:${jsondata.Name} - 身份证号:${jsondata.IDCardNo}`
        this.msgList.push('解析:' + str)
        this.imgUrl = "data:image/bmp;base64," + jsondata.PhotoBase64
      }
    },
    clear() {
      this.msgList = []
    },
    // 获取设备信息
    getGPY() {
      this.$rqt.GPY_GetAllDisplayInfo().then(res => {
        console.log(res);
      })
    },
    // 打开视频
    openGPY() {
      var data = {
        dev_idx: "0", // 摄像头 id
        res_id: "0" // 分辨率索引
      }
      this.$rqt.GPY_StartPreview(data).then(res => {
        if (res.returnCode == "0" || res.returnCode == "2") {
          this.farmTime = setInterval(() => {
            this.getFrame()
          }, 300);
        }
      })
    },
    // 获取针
    getFrame() {
      this.$rqt.GPY_getFrame().then(res => {
        if (res.returnCode == '0') {
          this.baseImg = "data:image/jpg;base64," + res.data.img
        }
      })
    },
    // 拍照
    takePhoto() {
      var data = {
        "filepath": "",                           // 待展平图片路径，为空时，拍照并展平，为本地图片全路径时，对图片展平
        "rotate": "0",                            // 旋转角度
        "camidx": "0",                            // 摄像头索引
        "cutpage": "0",                           // 
        "autoflat": {
          "flat": "1",
          "leftfilepath": "D://testleft.jpg",
          "rightfilepath": "D://testright.jpg",
          "removefinger": "1",
          "doublepage": "1"
        }
      }
      this.$rqt.GPY_autoflat(data).then(res => {
        console.log('高拍仪展平', res);
      })
    },
    // 展平拍照
    takePhotoZP() {

    },
    // 关闭高拍仪
    coloseGPY() {
      this.$rqt.GPY_StopPreview({
        dev_idx: "0"
      })
      clearInterval(this.farmTime)
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.idcard-title {
  min-height: 20vh;
  padding: 10px;
  border: 1px solid #ff0000;
  font-size: 6rem;
}

.sign-img {
  width: 100rem;
  height: 100rem;
  display: block;
}

.gpy-img {
  width: 120rem;
  height: 120rem;
}
</style>